import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { uniq } from 'lodash';
import React from 'react';
import { IRolesTenantsMapping } from 'types/authorization';
import { ITenant } from 'types/tenants';

const TenantsCell: React.FC<GridRenderCellParams<any>> = ({ row }) => {
	const display = React.useMemo(() => {
		const tenants = (row.mappings || [])
			.map((m: IRolesTenantsMapping) => m.tenants)
			.flat()
			.map((r: ITenant) => r?.name);

		return uniq(tenants).sort().join(', ');
	}, [row.mappings]);

	return (
		<Typography
			color="text.secondary"
			variant="body2"
			title={display}
			data-testid="tenants-cell"
		>
			{display}
		</Typography>
	);
};

export default TenantsCell;
